export default "__VITE_ASSET__C9hORfdl__"